var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 175C59.1775 175 25.6001 141.423 25.6001 100C25.6001 58.5774 59.1775 25 100.6 25C142.023 25 175.6 58.5774 175.6 100C175.6 141.423 142.023 175 100.6 175Z",
    fill: "url(#paint0_linear_26801_3929)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.611 49.1316V88.7001L129.858 52.9471C128.829 51.9218 127.444 51.3322 125.991 51.3006C124.539 51.269 123.13 51.7979 122.057 52.7775L92.1265 80.2211L70.166 65.5808C69.1595 64.9149 67.9663 64.5885 66.7611 64.6496C65.5558 64.7106 64.4017 65.1558 63.4676 65.9199L35.6001 88.7001V49.1316C35.6001 41.331 64.7112 35 100.605 35C136.5 35 165.611 41.331 165.611 49.1316Z",
    fill: "url(#paint1_linear_26801_3929)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.611 88.7001V111.311C165.611 103.51 136.5 97.179 100.605 97.179C64.7112 97.179 35.6001 103.51 35.6001 111.311V88.7001L63.4676 65.92C64.4017 65.1558 65.5558 64.7106 66.7611 64.6496C67.9663 64.5886 69.1595 64.9149 70.166 65.5808L92.1265 80.2211L122.057 52.7776C123.13 51.798 124.539 51.2691 125.991 51.3007C127.444 51.3322 128.829 51.9219 129.858 52.9472L165.611 88.7001Z",
    fill: "url(#paint2_linear_26801_3929)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.012 126.799C154.583 126.287 153.985 125.944 153.327 125.831C152.668 125.717 151.991 125.841 151.414 126.18C150.838 126.519 150.401 127.051 150.18 127.682C149.959 128.312 149.969 129.001 150.207 129.625C151.032 130.907 151.473 132.397 151.479 133.921C151.479 141.552 138.507 149.07 119.909 152.151C119.16 152.278 118.492 152.698 118.052 153.318C117.612 153.939 117.436 154.708 117.564 155.458C117.691 156.207 118.111 156.876 118.731 157.316C119.351 157.755 120.121 157.931 120.87 157.804C143.226 153.988 157.132 144.887 157.132 133.921C157.108 131.395 156.373 128.927 155.012 126.799Z",
    fill: "url(#paint3_linear_26801_3929)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.356 154.016L99.051 148.364C98.6213 148.116 98.134 147.985 97.6378 147.985C97.1417 147.985 96.6543 148.116 96.2247 148.364C94.6702 149.466 94.9528 150.879 94.9528 153.705C68.0463 152.518 49.7317 142.824 49.7317 133.921C49.759 132.436 50.1994 130.987 51.0036 129.738C51.2677 129.424 51.4601 129.055 51.5673 128.658C51.6745 128.262 51.6939 127.847 51.6242 127.442C51.5546 127.037 51.3975 126.652 51.1639 126.314C50.9304 125.976 50.6259 125.693 50.2718 125.485C49.9177 125.277 49.5225 125.148 49.1136 125.108C48.7048 125.068 48.2921 125.118 47.9044 125.254C47.5167 125.39 47.1632 125.608 46.8687 125.895C46.5741 126.181 46.3455 126.528 46.1988 126.912C44.8577 129.007 44.124 131.434 44.0791 133.921C44.0791 147.318 66.0113 158.001 94.9528 159.358V162.184C94.9543 162.666 95.0789 163.14 95.3148 163.56C95.5507 163.98 95.8901 164.333 96.3007 164.585C96.7113 164.837 97.1795 164.979 97.6609 165C98.1422 165.02 98.6208 164.917 99.051 164.7L110.356 159.047C110.819 158.81 111.208 158.45 111.479 158.006C111.75 157.562 111.894 157.052 111.894 156.532C111.894 156.012 111.75 155.501 111.479 155.058C111.208 154.614 110.819 154.253 110.356 154.016Z",
    fill: "url(#paint4_linear_26801_3929)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9054 57.1018V119.281C39.783 116.963 35.6001 114.137 35.6001 111.311V49.1316C35.6001 51.9579 39.783 54.7842 46.9054 57.1018Z",
    fill: "url(#paint5_linear_26801_3929)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.305 57.1018V119.281C161.428 116.963 165.611 114.137 165.611 111.311V49.1316C165.611 51.9579 161.428 54.7842 154.305 57.1018Z",
    fill: "url(#paint6_linear_26801_3929)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1264 63.2632C96.8092 63.2632 100.605 59.4671 100.605 54.7843C100.605 50.1015 96.8092 46.3053 92.1264 46.3053C87.4436 46.3053 83.6475 50.1015 83.6475 54.7843C83.6475 59.4671 87.4436 63.2632 92.1264 63.2632Z",
    fill: "url(#paint7_linear_26801_3929)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.777 106.134C136.242 105.824 136.788 105.658 137.347 105.658C138.097 105.658 138.816 105.956 139.346 106.486C139.876 107.016 140.173 107.735 140.173 108.484C140.173 109.043 140.008 109.59 139.697 110.054C139.386 110.519 138.945 110.882 138.429 111.095C137.912 111.309 137.344 111.365 136.796 111.256C136.247 111.147 135.744 110.878 135.349 110.483C134.953 110.088 134.684 109.584 134.575 109.036C134.466 108.487 134.522 107.919 134.736 107.403C134.95 106.886 135.312 106.445 135.777 106.134ZM83.1671 115.691L79.606 121.061C81.1712 122.031 82.378 123.485 83.0442 125.201C83.7103 126.918 83.7995 128.805 83.2983 130.577C82.7971 132.348 81.7327 133.909 80.266 135.022C78.7993 136.136 77.01 136.741 75.1687 136.747H69.516C68.7664 136.747 68.0475 136.45 67.5175 135.92C66.9875 135.39 66.6897 134.671 66.6897 133.921C66.6897 133.172 66.9875 132.453 67.5175 131.923C68.0475 131.393 68.7664 131.095 69.516 131.095H75.1687C75.9182 131.095 76.6371 130.797 77.1672 130.267C77.6972 129.737 77.995 129.018 77.995 128.268C77.995 127.519 77.6972 126.8 77.1672 126.27C76.6371 125.74 75.9182 125.442 75.1687 125.442C74.6501 125.46 74.1366 125.336 73.6843 125.081C73.232 124.827 72.8584 124.453 72.6044 124.001C72.3505 123.549 72.226 123.035 72.2445 122.516C72.2631 121.998 72.4241 121.494 72.7098 121.061L75.5361 116.963H69.516C68.7664 116.963 68.0475 116.665 67.5175 116.135C66.9875 115.605 66.6897 114.886 66.6897 114.137C66.6897 113.387 66.9875 112.668 67.5175 112.138C68.0475 111.608 68.7664 111.311 69.516 111.311H80.8213C81.3303 111.313 81.8291 111.453 82.2651 111.716C82.7011 111.978 83.058 112.354 83.2983 112.803C83.5386 113.251 83.6532 113.757 83.6301 114.265C83.607 114.774 83.4471 115.266 83.1671 115.691ZM101.51 116.963C99.8183 117.486 98.303 118.464 97.1291 119.79C98.8277 119.659 100.526 120.043 102.003 120.892C103.481 121.741 104.668 123.015 105.41 124.548C106.153 126.081 106.416 127.803 106.166 129.488C105.916 131.173 105.164 132.744 104.009 133.996C102.853 135.247 101.347 136.122 99.6871 136.505C98.0271 136.888 96.2902 136.763 94.7027 136.145C93.1151 135.527 91.7506 134.445 90.787 133.04C89.8233 131.635 89.3052 129.972 89.3002 128.269V125.894C89.3306 122.725 90.3489 119.644 92.2132 117.08C94.0775 114.517 96.695 112.599 99.7011 111.593C100.054 111.474 100.426 111.426 100.797 111.452C101.169 111.477 101.531 111.575 101.865 111.74C102.198 111.905 102.495 112.135 102.74 112.415C102.985 112.695 103.172 113.021 103.29 113.374C103.409 113.726 103.457 114.099 103.432 114.47C103.407 114.841 103.309 115.204 103.144 115.537C102.978 115.871 102.749 116.168 102.469 116.413C102.188 116.657 101.863 116.844 101.51 116.963ZM96.2089 130.619C96.6737 130.929 97.2202 131.095 97.7792 131.095C98.5287 131.095 99.2476 130.797 99.7777 130.267C100.308 129.737 100.605 129.018 100.605 128.269C100.605 127.71 100.44 127.163 100.129 126.698C99.8186 126.234 99.3772 125.871 98.8607 125.657C98.3443 125.443 97.776 125.387 97.2278 125.496C96.6795 125.606 96.1759 125.875 95.7807 126.27C95.3854 126.665 95.1162 127.169 95.0072 127.717C94.8981 128.265 94.9541 128.834 95.168 129.35C95.3819 129.867 95.7442 130.308 96.2089 130.619ZM120.39 111.311C118.141 111.311 115.984 112.204 114.394 113.794C112.804 115.384 111.911 117.541 111.911 119.79V128.268C111.911 130.517 112.804 132.674 114.394 134.264C115.984 135.854 118.141 136.747 120.39 136.747C122.638 136.747 124.795 135.854 126.385 134.264C127.975 132.674 128.869 130.517 128.869 128.268V119.79C128.869 117.541 127.975 115.384 126.385 113.794C124.795 112.204 122.638 111.311 120.39 111.311ZM123.216 128.268C123.216 129.018 122.918 129.737 122.388 130.267C121.858 130.797 121.139 131.095 120.39 131.095C119.64 131.095 118.921 130.797 118.391 130.267C117.861 129.737 117.563 129.018 117.563 128.268V119.79C117.563 119.04 117.861 118.321 118.391 117.791C118.921 117.261 119.64 116.963 120.39 116.963C121.139 116.963 121.858 117.261 122.388 117.791C122.918 118.321 123.216 119.04 123.216 119.79V128.268Z",
    fill: "url(#paint8_linear_26801_3929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_3929",
    x1: 25.6001,
    y1: 36.7188,
    x2: 168.569,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_3929",
    x1: 100.605,
    y1: 35,
    x2: 100.605,
    y2: 88.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_3929",
    x1: 89.6001,
    y1: 71,
    x2: 89.4712,
    y2: 96.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_3929",
    x1: 121.855,
    y1: 125.79,
    x2: 161.773,
    y2: 156.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_3929",
    x1: 51.4963,
    y1: 125.095,
    x2: 102.811,
    y2: 179.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_3929",
    x1: 35.6001,
    y1: 84.2062,
    x2: 46.9054,
    y2: 84.2062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_3929",
    x1: 165.611,
    y1: 84.2062,
    x2: 154.305,
    y2: 84.2062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_3929",
    x1: 85.5022,
    y1: 46.3053,
    x2: 105.112,
    y2: 58.5295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_3929",
    x1: 66.6897,
    y1: 108.087,
    x2: 89.5006,
    y2: 156.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualTour);
export default __webpack_public_path__ + "static/media/Virtual-Tour.5518c510166292260af59b9c41d04dfc.svg";
export { ForwardRef as ReactComponent };